import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.17636 17.6652C9.63191 18.1116 10.3717 18.1116 10.8273 17.6652L16.6583 11.9506C17.1139 11.5041 17.1139 10.7791 16.6583 10.3326C16.2028 9.88615 15.463 9.88615 15.0074 10.3326L11.1662 14.1007V3.14292C11.1662 2.51074 10.6451 2 10 2C9.35494 2 8.83379 2.51074 8.83379 3.14292V14.0971L4.99258 10.3362C4.53703 9.88973 3.79721 9.88973 3.34166 10.3362C2.88611 10.7826 2.88611 11.5077 3.34166 11.9541L9.17272 17.6687L9.17636 17.6652Z",
		fill: "#0D2976"
	})
});
export default SvgArrowDown;
